import React from 'react';

const GroupsList = ({ groups, currentChatId, currentChatType, onGroupSelect }) => {
    return (
        <div className="groups-list">
            {groups.map(group => (
                <div 
                    key={group.id}
                    className={`group-item ${currentChatType === 'group' && currentChatId === group.id ? 'active' : ''}`}
                    onClick={() => onGroupSelect(group.id, 'group')}
                >
                    <div className="chat-avatar group-avatar">{group.avatar}</div>
                    <div className="chat-info">
                        <div className="chat-name">
                            {group.name}
                            <span className="group-badge">
                                <i className="fas fa-users"></i> {group.members.length}
                            </span>
                        </div>
                        <div className="chat-last-message">{group.lastMessage}</div>
                    </div>
                    <div className="chat-time">
                        {group.time}
                        {group.unread > 0 && <span className="unread-badge">{group.unread}</span>}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default GroupsList;
